import uuid from '../utils/uuid';
import { createMigration } from './utils';

export const migrationTo9_178 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            // skip any videos with only one slide -- this is to avoid updating editor scene designs
            if (map.get('slides').count() <= 1) {
                return;
            }
            map.get('slides').forEach((scene, i) => {
                // update slide level children
                scene.get('children').forEach((child, j) => {
                    if (child.get('classType') === 'TimeAwareMediaAsset') {
                        map.setIn(['slides', i, 'children', j, 'id'], uuid());
                    }
                });
            });
        });
    },
});
